/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import extractText from 'flarum/common/utils/extractText';
import type Mithril from 'mithril';
import BookshelvesListState from '../states/BookshelvesListState';
import BookshelvesPage, { type BookshelvesPageAttrs } from './BookshelvesPage';

export interface OwnBookshelvesPageAttrs extends BookshelvesPageAttrs {}

export default class OwnBookshelvesPage<CustomAttrs extends OwnBookshelvesPageAttrs = OwnBookshelvesPageAttrs> extends BookshelvesPage<CustomAttrs> {
	oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
		Reflect.apply(Page.prototype.oninit, this, [vnode]);

		if (!app.session.user) {
			m.route.set(app.route.all_book_collections());
		}

		// @ts-expect-error -- deliberate single-argument push, a title would land on the stack.
		app.history.push('book_collections');
		this.bodyClass = 'App--bookshelves';
		app.setTitle(extractText(app.translator.trans('glowingblue-orell-bookshelf.forum.bookshelves.own_title')));

		this.state = new BookshelvesListState();

		this.state.refresh();
	}

	static initAttrs(attrs: OwnBookshelvesPageAttrs) {
		super.initAttrs(attrs);

		attrs.isOwn = true;
	}
}
